module.exports = __webpack_public_path__ + "static/img/kuaidi.4d032ebd.png";